export const DEFAULT_ERROR_MESSAGE =
	'Something went wrong. Try refreshing the page and contact technical support if the problem persists.';
